import { render, staticRenderFns } from "./VisitPointCreateTabAccount.vue?vue&type=template&id=b7780462"
import script from "./VisitPointCreateTabAccount.vue?vue&type=script&lang=js"
export * from "./VisitPointCreateTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports